import { render } from "./CouponDetails.vue?vue&type=template&id=410b1b82&scoped=true&ts=true"
import script from "./CouponDetails.vue?vue&type=script&lang=ts"
export * from "./CouponDetails.vue?vue&type=script&lang=ts"

import "./CouponDetails.vue?vue&type=style&index=0&id=410b1b82&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410b1b82"]])

export default __exports__